export const getVisibleExpenseRows = (gridRows = []) =>
  Array.from(gridRows ?? [])
    .filter((row) => row.visible === true && row.dataItem)
    .map((row) => row.dataItem);
